import React from "react";
import styled from "styled-components";
// Components
import BlogBox from "../Elements/BlogBox";
import FullButton from "../Buttons/FullButton";
import TestimonialSlider from "../Elements/TestimonialSlider";

export default function Blog() {
  return (
    <Wrapper id="blog">
      <div className="whiteBg">
        <div className="container">
          <HeaderInfo>
            <h1 className="font40 extraBold">Our Blog Stories</h1>
            <p className="font13">
Insights, updates, and expert advice on technology, AI, software development, and digital innovation.              <br />
            </p>
          </HeaderInfo>
       <div className="row textCenter">
  <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
    <BlogBox
      title="How AI is Transforming Modern Businesses"
      text="Explore how AI solutions streamline operations, enhance decision-making, and drive innovation across industries."
      tag="Artificial Intelligence"
      author=""
      action={() => window.location.hash = "#/blog/ai-transforming-businesses"}
    />
  </div>
  <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
    <BlogBox
      title="Top AI Trends to Watch in 2025"
      text="A deep dive into emerging AI technologies, including natural language processing, computer vision, and intelligent automation."
      tag="Artificial Intelligence"
      author=""
      action={() => window.location.hash = "#/blog/ai-trends-2025"}
    />
  </div>
  <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
    <BlogBox
      title="Building Smarter AI Assistants for Your Organization"
      text="Tips and strategies for implementing AI-powered assistants that improve productivity and customer experience."
      tag="Artificial Intelligence"
      author=""
      action={() => window.location.hash = "#/blog/smarter-ai-assistants"}
    />
  </div>
</div>

<div className="row textCenter">
  <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
    <BlogBox
      title="Machine Learning for Predictive Analytics: A Beginner’s Guide"
      text="How businesses can leverage ML algorithms to forecast trends, optimize processes, and make data-driven decisions."
      tag="Artificial Intelligence"
      author=""
      action={() => window.location.hash = "#/blog/ml-predictive-analytics"}
    />
  </div>
  <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
    <BlogBox
      title="AI in Mobile & Web Applications: Enhancing User Experience"
      text="Examples of AI integration in apps to deliver personalization, smarter recommendations, and automation."
      tag="Artificial Intelligence"
      author=""
      action={() => window.location.hash = "#/blog/ai-mobile-web-apps"}
    />
  </div>
</div>

        </div>
      </div>
      <div className="lightBg" style={{padding: '50px 0'}}>
        <div className="container">
          <HeaderInfo>
            <h1 className="font40 extraBold">What They Say?</h1>
            <p className="font13">
              Your success is our reputation.
              <br />
              Here’s what our clients have to say about us.
            </p>
          </HeaderInfo>
          <TestimonialSlider />
        </div>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.section`
  width: 100%;
  padding-top: 20px;
`;
const HeaderInfo = styled.div`
  margin-bottom: 30px;
  @media (max-width: 860px) {
    text-align: center;
  }
`;